export const applySearchTermToInvoices = (invoices: any[], searchTerm) => {
  searchTerm = searchTerm.trim();
  if (!searchTerm) return invoices;
  const numeric_regex = /^\d+$/;
  const idSearch = searchTerm.match(numeric_regex) !== null;

  if (idSearch) {
    return invoices.filter((x) => x.invoiceId.toString() === searchTerm);
  } else {
    return invoices.filter((x) => x.name.toLowerCase().includes(searchTerm.toLowerCase()));
  }
};
